<lib-bottom-sheet [open]="isOpen$$()" [settings]="sheetSettings" [backdropClickToClose]="false" [recalculate]="sheetPhase$$()" contentBackground="var(--0-5-Cards)" (closed)="handleCancel()" (dismissed)="handleCancel()">
  <div class="sheet">
    @switch (sheetPhase$$()) {
      @case ('connecting') {
        <div class="visual connecting" role="status" aria-live="polite" aria-busy="true">
          <ion-icon name="hunting-connecting" class="illustration" aria-hidden="true"></ion-icon>
        </div>
        <div class="content">
          <h3 class="title">{{ 'huntingProducts.wifiConnect.connecting.title' | transloco }}</h3>
          <p class="hint">{{ 'huntingProducts.wifiConnect.connecting.body' | transloco: { deviceName: deviceName$$() } }}</p>
        </div>
      }
      @case ('liveStreamStarting') {
        <div class="visual connecting">
          <ion-icon name="hunting-setup-stream" class="illustration" aria-hidden="true"></ion-icon>
        </div>
        <div class="content">
          <h3 class="title">{{ 'huntingProducts.liveStream.settingUp' | transloco }}</h3>
        </div>
      }
      @case ('failed') {
        <div class="visual failed">
          <ion-icon name="hunting-wifi-connectivity" class="illustration" aria-hidden="true"></ion-icon>
        </div>
        <div class="content">
          <h3 class="title">{{ 'huntingProducts.wifiConnect.failed.title' | transloco }}</h3>
          <p class="body">{{ 'huntingProducts.wifiConnect.failed.body' | transloco }}</p>
        </div>
        <ion-buttons class="actions">
          <lib-app-button expand="block" fill="solid" color="primary" [loading]="isRetrying$$()" (click)="handleRetry()" data-testid="wifi-connect-retry">
            {{ 'huntingProducts.wifiConnect.actions.retry' | transloco }}
          </lib-app-button>
          <lib-app-button expand="block" fill="clear" color="secondary" [disabled]="isRetrying$$()" (click)="handleCancel()" data-testid="wifi-connect-cancel">
            {{ 'huntingProducts.wifiConnect.actions.cancel' | transloco }}
          </lib-app-button>
        </ion-buttons>
      }
      @case ('liveStreamFailed') {
        <div class="visual failed">
          <ion-icon name="hunting-wifi-connectivity" class="illustration" aria-hidden="true"></ion-icon>
        </div>
        <div class="content">
          <h3 class="title">{{ 'huntingProducts.liveStream.error' | transloco }}</h3>
          @if (liveStreamError$$(); as errorDetail) {
            <p class="body error-detail" data-testid="wifi-connect-live-stream-error">{{ errorDetail }}</p>
          }
        </div>
      }
    }
  </div>
</lib-bottom-sheet>
